import React, { useEffect, useState } from 'react';
import {
  Chart as ChartJS,
  LinearScale,
  CategoryScale,
  BarElement,
  PointElement,
  LineElement,
  Legend,
  Tooltip,
  registerables as registerablesJS,
} from 'chart.js';
import { Color, ChartDataSet } from '../../types/app/chart.types';
import { Chart } from 'react-chartjs-2';
import { Grid } from '@mui/material';
import ResizableBox from '../../components/app/ResizableBox/ResizableBox';
import { ThemeType } from '../../hooks/useLocalTheme';
import { GRAY } from '../../utils/core/functions/colors.function';

ChartJS.register(...registerablesJS);
ChartJS.register(
  LinearScale,
  CategoryScale,
  BarElement,
  PointElement,
  LineElement,
  Legend,
  Tooltip,
);

interface Props {
  chartData: ChartDataSet[];
  labels: string[];
  displayLegend?: boolean;
  chartHeight?: string;
  chartWidth?: string;
  chartTitle?: string;
  localTheme?: ThemeType;
}

export function ChartsStateQtyContainer({
  chartData,
  labels,
  displayLegend = true,
  chartHeight,
  chartWidth,
  chartTitle,
  localTheme,
}: Props) {
  const preparedData = {
    labels,
    datasets: chartData.map((dataset: ChartDataSet) => {
      return {
        type: dataset.chartType as any,
        label: dataset.label,
        backgroundColor: dataset.colors.map(
          (color: Color) => 'rgb(' + color.r + ',' + color.g + ',' + color.b + ')',
        ),
        borderColor: dataset.style.borderColor,
        borderWidth: dataset.style.borderWidth,
        data: dataset.y,
        skipNull: true,
      };
    }),
  };

  const setSize = () => {
    if (labels.length < 10) {
      setHeightNum(600);
    }
    if (labels.length > 10) {
      setHeightNum(700);
    }
  };

  const [heightNum, setHeightNum] = useState<any>(0);
  const [isSharedRow, setIsSharedRow] = useState<boolean>(true);
  useEffect(() => {
    let maxLabelLength = 0;
    labels.map((label: any) =>
      maxLabelLength < label.length ? (maxLabelLength = label.length) : '',
    );
    setSize();
    if (labels.length > 10 || maxLabelLength > 30) setIsSharedRow(false);
  }, [preparedData]);

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      yAxes: {
        grid: {
          color:
            localTheme && localTheme === ThemeType.DARK
              ? `rgb(${GRAY.r},${GRAY.g},${GRAY.b})`
              : undefined,
        },
      },
      xAxes: {
        grid: {
          color:
            localTheme && localTheme === ThemeType.DARK
              ? `rgb(${GRAY.r},${GRAY.g},${GRAY.b})`
              : undefined,
        },
      },
    },
    options: {
      autoSkip: true,
      animation: false,
    },
    plugins: {
      legend: {
        display: displayLegend,
      },
      title: {
        display: true,
        text: chartTitle ? chartTitle : '',
      },
    },
  };

  return (
    <>
      <Grid
        item
        xs={isSharedRow ? 6 : 12}
        mt={2}
        style={{
          width: '100%',
          // height: isSharedRow ? '80vh' : heightNum,
          padding: 0,
          margin: 0,
        }}
      >
        <ResizableBox
          height={heightNum}
          width={
            isSharedRow
              ? visualViewport && visualViewport.width * 0.4
              : visualViewport && visualViewport.width * 0.84
          }
        >
          <Chart type="bar" data={preparedData} options={options} />
        </ResizableBox>
      </Grid>
    </>
  );
}
